import $ from 'jquery';
import CreateObjectForm from 'modules/housing/create-object-form/form';
import { cacheBody } from 'object-cache';
import ScrollToElement from 'lib/scrollToElement';
import SwiperVideoWidget from 'modules/widget/swiper/video-slider-widget';
import SwiperBeforeAfter from 'modules/widget/swiper/before-after';

import 'theme/moydom/less/pages/landing.less';
import 'theme/moydom/less/pages/main.less';
import 'theme/moydom/less/pages/house-add.less';
import 'theme/moydom/less/blocks/message.less';

import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Grid, Scrollbar, Thumbs } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/grid';
import 'swiper/scss/scrollbar';
import 'swiper/scss/effect-fade';
import 'swiper/scss/thumbs';

$(() => {
    const scrollTo = new ScrollToElement();
    const form = new CreateObjectForm();

    if ($('.js-scroll-to-element').length > 0) {
        scrollTo.init($('.js-scroll-to-element'));
    }
    if ($('#user_home_card_create_form').length > 0) {
        form.init($('#user_home_card_create_form'));
    }

    // слайдер для карты - большие блоки
    const swiperMap = document.querySelector('.js-interactive-map-slider');

    if (swiperMap) {
        new Swiper('.js-interactive-map-slider', {
            modules: [Navigation],
            spaceBetween: 20,
            watchOverflow: true,
            nested: true,
            loop: false,
            slidesPerView: 1.5,
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                320: {
                    slidesPerView: 1.1
                },
                360: {
                    slidesPerView: 1.2
                },
                380: {
                    slidesPerView: 1.3
                },
                400: {
                    slidesPerView: 1.4
                },
                450: {
                    slidesPerView: 1.6
                },
                500: {
                    slidesPerView: 1.7
                },
                540: {
                    slidesPerView: 1.9
                },
                600: {
                    slidesPerView: 2
                }
            },
            navigation: {
                nextEl: ".js-interactive-map-slider .swiper-button-next",
                prevEl: ".js-interactive-map-slider .swiper-button-prev"
            },
        });
    }

    // слайдер для карты - мелкие блоки в столбец
    const swiperMapMin = document.querySelector('.js-interactive-map-slider-min');

    if (swiperMapMin) {
        new Swiper('.js-interactive-map-slider-min', {
            modules: [Navigation, Grid],
            spaceBetween: 15,
            // watchOverflow: true,
            // nested: true,
            // loop: false,
            slidesPerView: 1,
            grid: {
                rows: 3,
            },
            navigation: {
                nextEl: ".js-interactive-map-slider-min .swiper-button-next",
                prevEl: ".js-interactive-map-slider-min .swiper-button-prev"
            },
        });
    }

    const swiperVideo = new SwiperVideoWidget().init();
    const swiperBeforeAfter = new SwiperBeforeAfter().init();


    const swiperCityNotificationLast = document.querySelector('.js-swiper-cityNotificationLast');

    if (swiperCityNotificationLast) {
        new Swiper('.js-swiper-cityNotificationLast', {
            modules: [Navigation, Scrollbar],
            watchOverflow: true,
            nested: true,
            loop: false,
            slidesPerView: 1.2,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 15
                },
                320: {
                    slidesPerView: 1.1,
                    spaceBetween: 15
                },
                360: {
                    slidesPerView: 1.2,
                    spaceBetween: 15
                },
                380: {
                    slidesPerView: 1.3,
                    spaceBetween: 15
                },
                400: {
                    slidesPerView: 1.4,
                    spaceBetween: 15
                },
                550: {
                    slidesPerView: 1.6,
                    spaceBetween: 40
                },
                700: {
                    slidesPerView: 1.8,
                    spaceBetween: 40
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 40

                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            },
            navigation: {
                nextEl: ".js-swiper-cityNotificationLast .swiper-button-next",
                prevEl: ".js-swiper-cityNotificationLast .swiper-button-prev"
            },
            scrollbar: {
                el: '.js-swiper-cityNotificationLast .swiper-scrollbar',
                draggable: true,
            }
        });
    }

    const swiperOtherServices = document.querySelector('.js-swiper-otherServices');

    if (swiperOtherServices) {
        new Swiper('.js-swiper-otherServices', {
            modules: [Navigation, Autoplay, Pagination],
            spaceBetween: 15,
            watchOverflow: true,
            nested: true,
            loop: true,
            slidesPerView: 1.2,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 15
                },
                320: {
                    slidesPerView: 1.1,
                    spaceBetween: 15
                },
                360: {
                    slidesPerView: 1.2,
                    spaceBetween: 15
                },
                380: {
                    slidesPerView: 1.3,
                    spaceBetween: 15
                },
                400: {
                    slidesPerView: 1.4,
                    spaceBetween: 15
                },
                550: {
                    slidesPerView: 1.6,
                    spaceBetween: 40
                },
                700: {
                    slidesPerView: 1.8,
                    spaceBetween: 40
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 40

                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            },
            navigation: {
                nextEl: ".js-swiper-otherServices .swiper-button-next",
                prevEl: ".js-swiper-otherServices .swiper-button-prev"
            },
            autoplay: {
                delay: 4000,
                pauseOnMouseEnter: true
            }
        });
    }

    // слайдер для цитат
    const swiperLeaderCity = document.querySelector('.js-swiper-leaderCityQuote');

    if (swiperLeaderCity) {
        const leaderCityThumbsSlider = new Swiper('.js-swiper-leaderCityThumbs', {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 'auto',
        });

        const quoteSlider = new Swiper('.js-swiper-leaderCityQuote', {
            modules: [EffectFade, Thumbs],
            loop: false,
            effect: "fade",
            slidesPerView: 1,
            thumbs: {
                swiper: leaderCityThumbsSlider,
            },
        });


    }
});
